module.exports = __webpack_public_path__ + "static/media/blue_temp.6b3c20e8.svg";